import React from 'react';
import { AwardIcon } from 'lucide-react';
export function Certificates() {
  return <section id="certificates" className="py-20 px-4 bg-gray-50" data-id="element-29">
      <div className="max-w-6xl mx-auto" data-id="element-30">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-800 mb-16" data-id="element-31">
          Certificates & Achievements
        </h2>
        <div className="flex flex-col items-center" data-id="element-32">
          <div className="mb-8" data-id="element-33">
            <AwardIcon className="h-16 w-16 text-blue-600" data-id="element-34" />
          </div>
          <h3 className="text-2xl font-semibold text-gray-800 mb-8 text-center" data-id="element-35">
            Certified Content Writer – Adeyeye Afeez
          </h3>
          <div className="w-full max-w-3xl rounded-xl shadow-md flex items-center justify-center mb-8 overflow-hidden" data-id="element-36">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pXjVnd9Tj9JU4Wa5J98axg/Screenshot_2025-05-18_152502.png" alt="Article Writing Skill Certificate" className="w-full h-auto" data-id="element-37" />
          </div>
          <p className="text-lg text-gray-600 max-w-2xl text-center" data-id="element-38">
            This certification validates my expertise in content creation, SEO
            best practices, and effective communication strategies. The 3-day
            online skill training by APX SKILLUP INSTITUTE has enhanced my
            article writing capabilities.
          </p>
        </div>
      </div>
    </section>;
}